module.exports = __webpack_public_path__ + "static/media/location.596f3053.svg";